var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('div', {
    staticClass: "d-flex justify-center align-center fill-height",
    class: {
      disabled: _vm.disabled
    }
  }, [_vm.shows ? _c('v-checkbox', _vm._b({
    staticClass: "d-inline-block my-0 py-0 mr-n8",
    attrs: {
      "color": "primary",
      "hide-details": ""
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.isSelected,
      callback: function ($$v) {
        _vm.isSelected = $$v;
      },
      expression: "isSelected"
    }
  }, 'v-checkbox', {
    readonly: _vm.readonly,
    disabled: _vm.disabled
  }, false)) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }